import angular from 'angular'
import routers from './routers'

import { drawback } from 'redevConfig'
const list = (drawback && drawback.list) || ''
const drawbackCtrl = list ? require(`redevelopment/input/drawback/${list.controllerName}`) : require('./drawbackCtrl.js')

export default angular.module('input.certification.drawback', []).config(['$stateProvider', ($stateProvider) => {
    Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
    })
}]).controller('drawbackCtrl', drawbackCtrl.default)
    .filter('secondDate', () => function (data) {
        if (!data) return data
        if (data.length < 11) return data += ' 00:00'
        if (data.length == 16) return data
        return data.substring(0, data.length - 3)
    })
    .name


// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/drawback/index.js